import axios from 'axios';

export default {
  async fetchErrorLogs({ commit }, options = {}) {
    commit('setLoading', true);
    try {
      const {
        append = false,
        limit = 100,
        skip = 0,
        q = '',
        status = '',
        companyId = '',
        tenantId = '',
      } = options;

      const response = await axios.get('/errorLogs', {
        params: {
          limit,
          skip,
          q,
          status,
          company_id: companyId,
          tenant_id: tenantId,
        },
      });

      const logs = Array.isArray(response.data) ? response.data : [];
      commit(append ? 'appendErrorLogs' : 'setErrorLogs', logs);

      return logs;
    } catch (err) {
      if (!options?.append) commit('setErrorLogs', []);
      throw err;
    } finally {
      commit('setLoading', false);
    }
  },
};
